import React from 'react';
import { motion } from 'framer-motion';
import { CheckCheck } from 'lucide-react';
interface ChatBubbleProps {
  message: string;
  isUser: boolean; // true = user (green, right), false = them (white, left)
  timestamp: string;
  status?: 'sent' | 'delivered' | 'read' | 'none';
  delay?: number;
}
export function ChatBubble({
  message,
  isUser,
  timestamp,
  status = 'none',
  delay = 0
}: ChatBubbleProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 10,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    y: 0,
    scale: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay
  }} className={`flex w-full mb-3 ${isUser ? 'justify-end' : 'justify-start'}`} data-id="element-203">
      <div className={`relative max-w-[85%] sm:max-w-[70%] px-4 py-2 rounded-lg shadow-sm text-[15px] leading-snug ${isUser ? 'bg-[#DCF8C6] rounded-tr-none' : 'bg-white rounded-tl-none'}`} data-id="element-204">
        <p className="text-[#1A1A1A] whitespace-pre-wrap" data-id="element-205">{message}</p>
        <div className="flex items-center justify-end gap-1 mt-1" data-id="element-206">
          <span className="text-[11px] text-gray-500" data-id="element-207">{timestamp}</span>
          {isUser && status !== 'none' && <CheckCheck className={`w-3.5 h-3.5 ${status === 'read' ? 'text-[#34B7F1]' : 'text-gray-400'}`} data-id="element-208" />}
        </div>

        {/* Triangle tail for speech bubble effect */}
        <div className={`absolute top-0 w-0 h-0 border-[6px] border-transparent ${isUser ? 'right-[-6px] border-t-[#DCF8C6] border-l-[#DCF8C6]' : 'left-[-6px] border-t-white border-r-white'}`} data-id="element-209" />
      </div>
    </motion.div>;
}